<script setup lang="ts">

import { LINKS } from '@presentation/Types/Settings';

</script>

<template>

    <Page>
    
        <div class="grid grid-cols-1 md:grid-cols-2 justify-center gap-4 md:gap-6 xl:gap-14 2xl:gap-64">
        
            <!-- CONSUMER -->
            <div class="justify-self-end w-[60vw] md:max-w-[260px] scale-90 2xl:scale-110">
                <a :href="LINKS.ConsumerTermsAndConditions"
                    target="_blank"
                    class="block transition-transform duration-300 ease hover:-translate-y-4">
                    <Image src="/TermsAndConditions/consumer-toc.png" />
                </a>
                <div class="w-[90%] h-8 absolute -bottom-16 transition-all duration-500 ease"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />
                <div class="w-full text-center -left-2 text-sm 2xl:text-base top-4 text-white/40">
                    <strong>Consumer</strong>
                    <br/>
                    Terms &amp; Conditions
                </div>
            </div>

            <!-- DEALER -->
            <div class="justify-self-end w-[60vw] md:max-w-[260px] scale-90 2xl:scale-110">
                <a :href="LINKS.DealerTermsAndConditions"
                    target="_blank"
                    class="block transition-transform duration-300 ease hover:-translate-y-4">
                    <Image src="/TermsAndConditions/dealer-toc.png" />
                </a>
                <div class="w-[90%] h-8 absolute -bottom-16 transition-all duration-500 ease"
                    style="background-image: radial-gradient( ellipse farthest-side at center, rgba( 0,0,0, 0.2 ) 0%, transparent 100%);" 
                />
                <div class="w-full text-center -left-2 text-sm 2xl:text-base top-4 text-white/40">
                    <strong>Dealer</strong>
                    <br/>
                    Terms &amp; Conditions
                </div>
            </div>

        </div>

    </Page>

</template>